export const getHelpData = (store) => store.helpForm.editData;
